import { compositionIdentityTokenUrl } from '../urls';
import refresh from '../refresh';

export default async function getCompositionIdentityToken(orgId, uuid, version) {
  const url = `${compositionIdentityTokenUrl}?${new URLSearchParams({
    ...(orgId && { org: orgId }),
    uuid,
    version,
  })}`;
  return refresh(async () => {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}
